import {FormApi} from 'final-form';
import * as dotObject from 'dot-object';
import {get, set} from 'lodash'
import getRefId from './getRefId';

// Final form kan niet omgaan met een nesting van meer dan 2 niveaus.
// Daarom loopen we nu zelf door de formValues en updaten we deze handmatig.
const formStateUpdate = (form: FormApi<Record<string, any>>, values: any): void => {
  const dotObjectValues = dotObject.dot(values);
  const fieldArrays = new Set<string>();
  const fieldObjects = new Set<string>();
  form.batch(() => {
    for (const [key, value] of Object.entries(dotObjectValues)) {
      form.change(key, value);
      let k = key;
      while (/\.\w+$/.test(k) || /\[\d+\]$/.test(k)) {
        // remove the last part of a field array key
        // keeping only the array key for later use
        // Hypotheekgever.1.Onderneming|.0.Something|
        if (/\[\d+\]$/.test(k)) {
          fieldObjects.add(k);
          k = k.replace(/^(.*)\[\d+\]$/, '$1');
          fieldArrays.add(k);
          continue;
        }
        if (/\.\w+$/.test(k)) {
          k = k.replace(/^(.*)\.\w+$/, '$1');
          fieldObjects.add(k);
          continue;
        }
      }
    }
    for (const objectKey of [...fieldObjects].sort((a, b) => a.length - b.length)) {
      // Each object should have an unique id on init
      const id = get(values, `${objectKey}.id`, getRefId());
      form.change(`${objectKey}.id`, id);
      set(values, `${objectKey}.id`, id)
      form.change(objectKey, get(values, objectKey, {}));
    }
    for (const arrayKey of [...fieldArrays].sort((a, b) => a.length - b.length)) {
      // Also update array values as actual arrays in form
      form.change(arrayKey, get(values, arrayKey, []));
    }
  });
}

export default formStateUpdate;
